import tableRelatedMainHubPriorityMedias from './tableRelatedMainHubPriorityMedias';

export default {
  title: 'Priority Medias',
  attributeName: 'priorityMedias',
  getURL: 'mainHubs/mainHubId/composeExperiences',
  createURL: '',
  updateURL: '',
  removeURL: '',
  itemName: 'name',
  itemId: 'id',
  sessionParams: ['mainHubId'],
  tableConfig: tableRelatedMainHubPriorityMedias,
};